import { Form, Select, Button, DatePicker, Segmented } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import {
  getCurrentDateRange,
  customWeekStartEndFormat,
} from "../../../utilities/report";

import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getSummary,
  setMachinesSummary
}) => {
  return (
    <div className="w-fit px-8 py-6">
      <div className="justify-end flex items-center h-full space-x-5 ">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            placeholder="Select Company"
            optionFilterProp="label"
            showSearch
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                company,
              });
              console.log("");
              setConfig({
                ...config,
                templates: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template: undefined,
              });
              setMachinesSummary([])
            }}
          />
        </Form.Item>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
              });
              setMachinesSummary([])
            }}
          />
        </Form.Item>

        <Form.Item name="range" label=" " colon={false} layout="vertical">
          <Segmented
            className="bg-gray-200"
            options={[
              { label: "Weekly", value: "week" },
              { label: "Monthly", value: "month" },
            ]}
            value={get(filter, "interval")}
            defaultValue={"week"}
            onChange={(interval) => {
              setFilters({
                ...filter,
                interval,
                date: getCurrentDateRange(interval, dayjs()),
              });
              setMachinesSummary([])
            }}
          />
        </Form.Item>
        <div className="mt-8 ">
          {get(filter, "interval") === "week" ? (
            <DatePicker
              onChange={(value, dateString) => {
                setFilters({
                  ...filter,
                  date: getCurrentDateRange(get(filter, "interval"), value),
                });
              }}
              style={{ minWidth: 250 }}
              format={customWeekStartEndFormat}
              showWeek={false}
              value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
              picker="week"
            />
          ) : (
            <DatePicker
              style={{ minWidth: 250 }}
              format={"MM-YYYY"}
              onChange={(value, dateString) => {
                setFilters({
                  ...filter,
                  date: getCurrentDateRange(get(filter, "interval"), value),
                });
              }}
              value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
              picker="month"
            />
          )}
        </div>
        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={getSummary}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
